import { sendGAEvent } from '../../domain/marketing/gtm-provider';
import { getABTest } from '../../domain/abtest/abtest-provider';
import { useEffect, useState } from 'react';
import { round1DecimalPlace, round2DecimalPlaces } from '../../domain/math-provider';

/*  ----- To Compile ------
list-page-min.js
product-page-min.js
subscriptions-min.js
daily-deals-min.js
wish-list-min.js
waves-min.js
compare-bundles-min.js
cart-min.js
olp-preset-min.js
recently-viewed-products-min.js
 */
export interface IStarRatingProps {
    rating: number,
    reviews: number,
    url?: string,
    urlHashHide?: boolean,
    urlHash?: string,
    gaEventName?: string,
    gaEventValue?: string,
    className?: string,
    colorClass?: string,
    clickByAttribute?: string,
}

/**
 * Star rating.
 */
const StarRating = (props: IStarRatingProps) => {

    const [showRatingScore, setShowRatingScore] = useState(false);

    useEffect(() => {
        const abtest = getABTest('RatingScore');
        if(!abtest?.isActive) return;
        setShowRatingScore(abtest.selected === 'on');
    }, []);

    const int_part = Math.trunc(props.rating);
    const float_part = Number((props.rating-int_part).toFixed(2));
    //console.log('StarRating: ',props);
    //fix float star:
    // 0... -0.11 - width+ 6 <<<<
    // 0.11-0.25 - width+ 7
    // 0.26-0.35 - width+ 8
    // 0.36-0.45 - width+ 9
    // 0.46-0.55 - width+ 10
    // 0.56-0.65 - width+ 11
    // 0.66-0.75 - width+ 12
    // 0.76-0.85 - width+ 13
    // 0.86-0.95 - width+ 14
    // 0.86-1    - width+ 20 <<<<
    var fixed_float_part = 0;
    if(float_part > 0){
        switch (true) {
            case (float_part < 0.11):
                fixed_float_part = 6;
                break;
            case (float_part < 0.25):
                fixed_float_part = 7;
                break;
            case (float_part < 0.35):
                fixed_float_part = 8;
                break;
            case (float_part < 0.45):
                fixed_float_part = 9;
                break;
            case (float_part < 0.55):
                fixed_float_part = 10;
                break;
            case (float_part < 0.65):
                fixed_float_part = 11;
                break;
            case (float_part < 0.75):
                fixed_float_part =12;
                break;
            case (float_part < 0.85):
                fixed_float_part = 13;
                break;
            case (float_part < 0.95):
                fixed_float_part = 14;
                break;
            case (float_part < 1):
                fixed_float_part = 20;
                break;
            default:
                fixed_float_part = 0;
        }
    }

    const width = int_part * 20 + fixed_float_part;

    /**
     * on click -> send GA events
     */
    const handleClick = () => {
        if(props.clickByAttribute) {
            const carouselCLick:any = document.querySelectorAll(props.clickByAttribute)
            //console.log('handleClick: ',carouselCLick);
            if(carouselCLick && carouselCLick[0])
                carouselCLick[0].click();
        }
        sendGAEvent(
            props.gaEventName ? props.gaEventName : 'Click',
            props.gaEventValue ? props.gaEventValue : 'Reviews');
    };

    return (
        props.reviews > 0 && props.rating > 0 ? (
            <a
                aria-label={`${ props.reviews } User ${ props.reviews === 1 ? 'review' : 'reviews' }, rating ${ props.rating } ${ props.rating === 1 ? 'star' : 'stars' }`}
                href={ `${ props.url || '' }${ props.urlHashHide ? '' : '#'}${ props.urlHash && props.urlHash !== '' && !props.urlHashHide ? props.urlHash : props.urlHashHide ?'':'reviews' }` }
                title=""
                onClick={ handleClick }
                className={ `flex items-center cursor-pointer no-underline ${ props.className ?? '' }` }>


                {
                    showRatingScore &&
                    <div className={ `text-sm font-bold line-height-normal ${props.colorClass ?? 'text-gray-500' } mr-1` }>{  round1DecimalPlace(props.rating) }</div>
                }

                <div className="star-rating relative whitespace-nowrap" style={{
                    marginTop: '-3px',
                }}>
                    <div
                        className="star-rating-content absolute overflow-hidden left-0 top-0 whitespace-nowrap"
                        style={{
                            width: `${ width }%`
                        }} />
                </div>

                <div className={ `text-sm font-bold ${props.colorClass ?? 'text-gray-500' }  ml-1` }>({ props.reviews })</div>
            </a>
        ) : <div />
    )
};

export default StarRating;